import React, { Component } from "react";
import { Button, Container, Row, Col, Label } from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../principal/containers/DataWrapper";
import {
  IconeCarregar,
  IconeDelete,
  IconeInformacao,
} from "../../comum/components/Icones";
import ModalAviso from "../../comum/components/ModalAviso";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import ControleAcessoService from "../../../services/ControleAcessoService";
import ControleAcessoStore from "../stores/ControleAcessoStore";
import FormInputSimples from "../../comum/components/FormInputSimples";
import Card from "../../comum/components/Card";
import FormOnlyPositiveNumberSimples from "../../comum/components/FormNumberSimples";
import CheckboxField from "../../comum/components/CheckboxField";
import FormSelectSimples from "../../comum/components/FormSelectSimples";
import { TabelaSelecaoMultipla } from "../../comum/components/TabelaSelecaoMultipla";
import ModalTermoAdesao from "../components/ModalTermoAdesao";
import { campoObrigatorio, dadosInvalidos } from "../../../utils/mensagens";
import lscache from "lscache";
import { AreaSelecaoContainers } from "../../agendamentoservicos/cadastrar/components/AreaSelecaoContainers";
import ModalCadastro from "../components/ModalCadastro";

@inject("store")
@DataWrapper
@observer
export class ControleAcesso extends Component {
  constructor(props) {
    super(props);
    this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    this.validacaoStore = this.props.store.validacaoStore;

    this.service = new ControleAcessoService();
    this.controller = new ControleAcessoStore(this.service);
  }

  componentDidMount() {
    this.tituloPaginaStore.setTitulo("Controle de acesso");
    this.props.store.appStore.showVoltarTopBar(false);
    setTimeout(
      function () {
        this.controller.modalAdesao = true;
      }.bind(this),
      1000
    );
  }

  handleSalvar = () => {
    this.controller.salvo = true;
    if (!this.invalido()) {
      this.controller.salvar();
    } else {
      this.controller.listaMensagens = [dadosInvalidos];
    }
  };

  alertaCpfCnpj = () => {
    if (this.controller.salvo) {
      if (this.controller.novoCadastro.Empresa.Cnpj.length === 0) {
        return campoObrigatorio;
      } else if (
        this.controller.novoCadastro.Empresa.Cnpj.length !== 11 &&
        this.controller.novoCadastro.Empresa.Cnpj.length !== 14
      ) {
        //É preciso verificar se possui 11 digitos ou 14 (mesmo sendo o máximo) pois 11 digitos equivale a um CPF e 14 um CNPJ
        return "CPF/CNPJ inválido";
      }
    }
    if (this.controller.alertaSemCadastro) {
      return this.controller.alertaSemCadastro;
    }
    return false;
  };

  invalido = () => {
    if (this.emailInvalido() !== false) return true;
    if (this.emailEmpresaInvalido() !== false) return true;
    if (this.alertaCpfCnpj() !== false) return true;

    return false;
  };

  emailInvalido = () => {
    if (this.controller.salvo) {
      if (this.controller.novoCadastro.Pessoa.Email.length === 0) {
        return campoObrigatorio;
      } else if (
        !this.validacaoStore.isEmail(this.controller.novoCadastro.Pessoa.Email)
      )
        return this.validacaoStore.getMensagemErro("isEmail");
      return false;
    }
    return true;
  };

  emailEmpresaInvalido = () => {
    if (process.env.rig && this.controller.novoCadastro.Empresa.Email.length === 0) {
      return campoObrigatorio;
    }
    if (
      this.controller.novoCadastro.Empresa.Email.length > 0 &&
      !this.validacaoStore.isEmail(this.controller.novoCadastro.Empresa.Email)
    )
      return this.validacaoStore.getMensagemErro("isEmail");
    return false;
  };

  modalAviso = () => {
    if (this.controller.listaMensagens)
      return (
        <ModalAviso
          onClickFechar={() => {
            this.controller.listaMensagens = false;
            this.controller.retornaHome && window.location.replace("/login");
          }}
        >
          {this.controller.listaMensagens.map((msg, x) => (
            <h2 key={x}>{msg}</h2>
          ))}
        </ModalAviso>
      );
  };

  modalCadastro = () => {
    if (this.controller.modalCadastro)
      return <ModalCadastro controller={this.controller} />;
  };

  modalTermoAdesao = () => {
    if (this.controller.modalAdesao)
      // TODO Remover negação
      return <ModalTermoAdesao controller={this.controller} />;
  };

  dadosDoUsuario = () => {
    let sm = 6;
    let md = 3;
    let lg = 3;
    let xl = 3;
    return (
      <Card className={"secao"} title={"Dados do usuário"}>
        <Row>
          <FormInputSimples
            titulo="Seu nome"
            xs={12}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
            dado={this.controller.novoCadastro.Pessoa.Nome}
            obrigatorio={true}
            alerta={
              this.controller.salvo &&
                this.controller.novoCadastro.Pessoa.Nome.length === 0
                ? campoObrigatorio
                : false
            }
            onChange={(event) =>
              (this.controller.novoCadastro.Pessoa.Nome = event.target.value.toUpperCase())
            }
          />
          <FormOnlyPositiveNumberSimples
            titulo="DDD"
            xs={1}
            sm={1}
            md={1}
            lg={1}
            xl={1}
            obrigatorio={true}
            dado={this.controller.novoCadastro.Pessoa.Ddd}
            limiteMaximo={4}
            alerta={
              this.controller.salvo &&
                (this.controller.novoCadastro.Pessoa.Ddd === 0 ||
                  this.controller.novoCadastro.Pessoa.Ddd.length === 0)
                ? campoObrigatorio
                : false
            }
            onChange={(event) =>
              (this.controller.novoCadastro.Pessoa.Ddd = parseInt(
                event.target.value
              ))
            }
          />
          <FormOnlyPositiveNumberSimples
            titulo="Telefone Comercial"
            xs={8}
            sm={4}
            md={2}
            lg={2}
            xl={2}
            obrigatorio={true}
            dado={this.controller.novoCadastro.Pessoa.Telefone}
            limiteMaximo={10}
            alerta={
              this.controller.salvo &&
                (this.controller.novoCadastro.Pessoa.Telefone === 0 ||
                  this.controller.novoCadastro.Pessoa.Telefone.length === 0)
                ? campoObrigatorio
                : false
            }
            onChange={(event) =>
              (this.controller.novoCadastro.Pessoa.Telefone = parseInt(
                event.target.value
              ))
            }
          />
          <FormOnlyPositiveNumberSimples
            titulo="Ramal"
            xs={12}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
            dado={this.controller.novoCadastro.Pessoa.Ramal}
            limiteMaximo={7}
            onChange={(event) =>
              (this.controller.novoCadastro.Pessoa.Ramal = parseInt(
                event.target.value
              ))
            }
          />
          <FormInputSimples
            titulo="Email"
            xs={12}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
            dado={this.controller.novoCadastro.Pessoa.Email}
            obrigatorio={true}
            alerta={this.emailInvalido()}
            onChange={(event) =>
              (this.controller.novoCadastro.Pessoa.Email = event.target.value.toUpperCase())
            }
          />
        </Row>
      </Card>
    );
  };
  //nao estava funcionando o campo "dado" para FormImputSimples, foi adicionado o campo value com o valor // fluig 5095572
  dadosDaEmpresa = (mda, lga, xla) => {
    let sm = 6;
    let md = 6;
    let lg = 6;
    let xl = 6;
    return (
      <Col xs={12} sm={12} md={mda} lg={lga} xl={xla}>
        <div className={"secao area-dados-empresa card"}>
          <div>
            <h2>
              Dados da empresa
              {!lscache.get("access_token") && (
                <label className="informacoes ml-2">
                  Não possui cadastro no Tecon?{" "}
                  <a onClick={this.controller.abrirCadastro}>Clique aqui</a>
                </label>
              )}
            </h2>
          </div>
          <Card className={"card-branco"}>
            <Row>
              <CheckboxField
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                titulo={"Possui representante no Brasil"}
                text={"Sim"}
                ativo={
                  this.controller.novoCadastro.Empresa.RepresentanteBrasil ===
                  "S"
                }
                onClick={() =>
                  (this.controller.novoCadastro.Empresa.RepresentanteBrasil =
                    this.controller.novoCadastro.Empresa.RepresentanteBrasil ===
                      "S"
                      ? "N"
                      : "S")
                }
              />
              <FormOnlyPositiveNumberSimples
                titulo="CPF/CNPJ"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                limiteMaximo={14}
                dado={this.controller.novoCadastro.Empresa.Cnpj}
                obrigatorio={true}
                alerta={this.alertaCpfCnpj()}
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.Cnpj =
                    event.target.value)
                }
                onBlur={() => this.controller.verificaEmpresa()}
              />
              <FormInputSimples
                titulo="Razão Social"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                dado={this.controller.novoCadastro.Empresa.Nome}
                value={this.controller.novoCadastro.Empresa.Nome}
                obrigatorio={true}
                bloqueado={this.controller.bloqueaRazao}
                alerta={
                  !this.controller.bloqueaRazao &&
                    this.controller.salvo &&
                    this.controller.novoCadastro.Empresa.Nome.length === 0
                    ? campoObrigatorio
                    : false
                }
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.Nome = event.target.value.toUpperCase())
                }
              />
              <FormInputSimples
                titulo="Endereço comercial"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                dado={this.controller.novoCadastro.Empresa.Endereco} 
                value={this.controller.novoCadastro.Empresa.Endereco}
                bloqueado={this.controller.bloqueaEndereco}
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.Endereco = event.target.value.toUpperCase())
                }
              />
              <FormSelectSimples
                titulo="País"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                itens={this.controller.paises}
                dado={this.controller.paisSelecionado}
                bloqueado={
                  this.controller.bloqueaPais || !this.controller.paises
                }
                onChange={(event) => this.controller.changePais(event)}
              />
              <FormSelectSimples
                titulo="Estado"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                itens={
                  this.controller.paisSelecionado
                    ? this.controller.ufs && this.controller.ufs.length > 0
                      ? this.controller.ufs.filter(
                        (uf) =>
                          uf.StateCntryCode ===
                          this.controller.paisSelecionado.value
                      )
                      : false
                    : false
                }
                dado={this.controller.ufSelecionada}
                bloqueado={
                  this.controller.bloqueaEstado ||
                  !this.controller.ufs ||
                  !this.controller.paisSelecionado
                }
                onChange={(event) => this.controller.changeUF(event)}
              />
              <FormInputSimples
                titulo="Cidade"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                dado={this.controller.novoCadastro.Empresa.Cidade}
                value={this.controller.novoCadastro.Empresa.Cidade}
                bloqueado={this.controller.bloqueaCidade}
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.Cidade = event.target.value.toUpperCase())
                }
              />
              <FormInputSimples
                titulo="CEP"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                dado={this.controller.novoCadastro.Empresa.CEP}
                value={this.controller.novoCadastro.Empresa.CEP}
                bloqueado={this.controller.bloqueaCep}
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.CEP = event.target.value.toUpperCase())
                }
              />
              <FormOnlyPositiveNumberSimples
                titulo="DDD"
                xs={12}
                sm={4}
                md={2}
                lg={2}
                xl={2}
                dado={this.controller.novoCadastro.Empresa.Ddd}
                limiteMaximo={4}
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.Ddd = parseInt(
                    event.target.value
                  ))
                }
              />
              <FormOnlyPositiveNumberSimples
                titulo="Telefone"
                xs={12}
                sm={4}
                md={4}
                lg={4}
                xl={4}
                dado={this.controller.novoCadastro.Empresa.Telefone}
                limiteMaximo={10}
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.Telefone = parseInt(
                    event.target.value
                  ))
                }
              />
              <FormInputSimples
                titulo="Email da empresa"
                xs={12}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
                dado={this.controller.novoCadastro.Empresa.Email}
                obrigatorio={process.env.rig}
                alerta={this.controller.salvo && this.emailEmpresaInvalido()}
                onChange={(event) =>
                  (this.controller.novoCadastro.Empresa.Email = event.target.value.toUpperCase())
                }
              />
            </Row>
          </Card>
        </div>
      </Col>
    );
  };

  areaSelecaoPerfis = (sm, md, lg, xl) => {
    return (
      <Col xs={12} sm={sm} md={md} lg={lg} xl={xl}>
        <Card className={"secao area-perfis"} title={"Perfis"}>
          <TabelaSelecaoMultipla
            listaCompleta={this.controller.perfis}
            colunas={this.controller.colunasPerfis}
            keyField={"Id"}
            marcar={this.controller.marcarPerfil}
            marcarTodos={false}
            carregando={false}
          />
          <div className="d-flex align-items-center ml-1">
            {this.controller.salvo &&
              this.controller.novoCadastro.Empresa.Perfis.length === 0 && (
                <Label className="label-danger">{campoObrigatorio}</Label>
              )}
          </div>
          <div className="d-flex align-items-center">
            <div>
              <IconeInformacao className="pr-1" />
            </div>
            <Label className="informacoes">
              Selecione acima o perfil de acesso ao portal.
            </Label>
          </div>
        </Card>
      </Col>
    );
  };

  areaInclusaoParceiros = (sm, md, lg, xl) => {
    return (
      <Col xs={12} sm={sm} md={md} lg={lg} xl={xl}>
        <Card className={"secao"} title={"CNPJ Parceiro Associado"}>
          <Card className="card-branco area-parceiros">
            {this.controller.atualizaParceiros &&
              this.controller.novoCadastro.Empresa.Parceiros.map((parc, x) => {
                return (
                  <Col
                    className="card-form"
                    key={x}
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                  >
                    <Row className={"row-area-parceiros"}>
                      <FormInputSimples
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        dado={parc}
                        limiteMaximo={14}
                        alerta={
                          this.controller.salvo &&
                            this.controller.novoCadastro.Empresa.Parceiros
                              .length > 0 &&
                            this.controller.novoCadastro.Empresa.Parceiros[x]
                              .length !== 14
                            ? "CNPJ inválido"
                            : ""
                        }
                        onChange={(event) =>
                          (this.controller.novoCadastro.Empresa.Parceiros[x] =
                            event.target.value)
                        }
                      />
                    </Row>
                    <div className="botao">
                      <IconeDelete
                        className="icone-delete"
                        tamanho="3x"
                        onClick={() => this.controller.removerParceiro(x)}
                      />
                    </div>
                  </Col>
                );
              })}
            <Button
              className="btn-primary"
              onClick={() => this.controller.adicionarParceiro()}
            >
              Adicionar outro CNPJ
            </Button>
          </Card>
          <div className="d-flex align-items-center">
            <div>
              <IconeInformacao className="pr-1" />
            </div>
            <Label className="informacoes">
              Informe acima o CPNJ do(s) parceiro(s) que deseja visualizar os
              dados.
            </Label>
          </div>
        </Card>
      </Col>
    );
  };

  form = () => {
    //ajustando conflito no arquivo
    let sm = 6;
    let md = 6;
    let lg = 3;
    let xl = 3;
    let smRig = 12;
    let mdRig = 12;
    let lgRig = 6;
    let xlRig = 6;
    return (
      <Card className="form-secoes">
        {this.dadosDoUsuario()}
        <Row>
          {this.dadosDaEmpresa(12, 6, 6)}
          {this.areaSelecaoPerfis(
            process.env.rig ? smRig : sm,
            process.env.rig ? mdRig : md,
            process.env.rig ? lgRig : lg,
            process.env.rig ? xlRig : xl
          )}
          {process.env.ssa && this.areaInclusaoParceiros(sm, md, lg, xl)}
        </Row>
      </Card>
    );
  };

  render() {
    return (
      <div className="form-wrapper">
        <Container className="controle-acesso tela-botoes-inclusao-topo" fluid>
          {this.modalTermoAdesao()}
          {this.modalCadastro()}
          {this.modalAviso()}
          <Row
            className={
              "botoes-inclusao-topo justify-content-end align-items-center"
            }
          >
            <div
              className="card-atencao mr-4"
              style={{ minWidth: "unset", margin: "5px", padding: "5px 20px" }}
            >
              <div className="card-atencao--title">Atenção</div>
              <Label className="mx-0 px-0">
                Os campos com <span className="label-danger">*</span> são de
                preenchimento obrigatório
              </Label>
            </div>
          </Row>
          {this.form()}
        </Container>
        <Footer>
          <FooterContent className="right-pos">
            <div>
              {!this.controller.salvando
                ? <Button className="btn-primary" onClick={() => this.handleSalvar()}>SALVAR</Button>
                : <IconeCarregar tamanho="2x" cor="#001C43" />
              }
            </div>
          </FooterContent>
        </Footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/controleacesso/telas/ControleAcesso.js